import Animation from "@quarkly/community-kit/Animation";
export default Animation;